import { observer } from "mobx-react-lite"
import { Button, Segment } from "semantic-ui-react"
import { v4 as uuid } from 'uuid';
import DynamicTableComponent from "../DynamicTable/DynamicTableComponent"
import { useStore } from "../../app/stores/store";
import { useEffect, useState } from "react";
import FileUpload from "../MediaAssets/Details/FileUpload";
import { toast } from "react-toastify";
import { ThreeDotLoader } from "../../app/layout/LoadingComponent";
const  Authorization = () => {
    const {CRMStore,CRMStore:{authorizationTable,handlelogisticsButton,handleAuthorizationModel,subtaskCompoent:{selectedRowDetails},loader,handleApproveTable,authorizationModel},dashboardStore,sidebarStore } = useStore();
    const [pageNumber,setPageNumber] = useState(0);

    useEffect(()=>{
     handleApproveTable(1);
     // eslint-disable-next-line
    },[])
    useEffect(()=>{
      handleAuthorizationModel();
       // eslint-disable-next-line
    },[sidebarStore.sidebar.open])
    const paginateFunction = (e:number) =>{
      handleApproveTable(e)
        dashboardStore.setTagPageNumFunc(e);
        setPageNumber(e);
    }
    const searchFunction = (column: any, order: any) => {
        console.log(order, column);
      };
      const updateApproveTable = () =>{
        handlelogisticsButton()
          if(CRMStore.fileUploadDetails.includes(selectedRowDetails?.id)){
            CRMStore.updateApproveTable(selectedRowDetails?.id,true,selectedRowDetails?.title)
            CRMStore.activePage = 'Logistics'
            CRMStore.handleAuthorizationModel();
          }
          else toast.error('Kindly before approve upload file.')
        }

        
  return (
    <div>
        <Segment>
          {CRMStore.authorizationModel ? (
          <Segment style={{display:'flex',justifyContent:'end'}}>
                {loader.buttonLoader ? (
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '48px',
                    }}
                  >
                    <ThreeDotLoader />
                  </div>
                ) : (
                  <>
                      <Button 
                        onClick={() =>
                          updateApproveTable()
                        }
                        color="green"
                      >
                        Approve
                      </Button>
                  </>
                )}
          </Segment>
            ) : null}
        <DynamicTableComponent
          key={uuid()}
          data={authorizationTable.tableData}
          name={'CRM Authorization'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={pageNumber}
          searchFuncData={searchFunction}
        />
        {authorizationModel ?  <div
         style={{margin:'10px',width:'50%'}}>
        <FileUpload
        elementName={'CRM Authorization'}
        filesUploaded={{ elementId: selectedRowDetails.id }}
        getUploadedFiles={()=>{}}
        index={0}
        isMandatory={true} errorMessage={""}  
        />
        </div> : null}
        </Segment>

    </div>
  )
}

export default observer(Authorization)